import { useMemo } from 'react';
import { generatePath } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import type { FollowUpOwner } from 'src/types/followUp';
import HttpService from 'src/services/api/http';
import { useUserContext } from 'src/components/app/context/UserContext';

const useOwnerListQuery = ({
  path,
  search,
}: {
  path: string;
  search: string;
}) => {
  const endpoint = useMemo(() => generatePath(path), [search]);
  const { currentSurvey } = useUserContext();

  return useQuery<Array<FollowUpOwner>>({
    queryKey: [endpoint, search, currentSurvey],
    queryFn: () =>
      HttpService.get(endpoint, {
        search,
        survey: currentSurvey?.id,
      })
        .then(({ data }) => data)
        .catch(({ response }) => Promise.reject(response.status)),
  });
};

export default useOwnerListQuery;
